export enum Currency {
  Eur = 'EUR',
  Usd = 'USD',
  Gbp = 'GBP',
}
